/* import __COLOCATED_TEMPLATE__ from './pending-invites-list-item.hbs'; */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { enqueueTask } from 'ember-concurrency';

const INVITE_STATUSES = {
  EXPIRED: "Expired",
  RESENT: "Re-sent",
  RESEND_FAILED: "Resend failed",
  NONE: ""
};

const CLASS_NAME = 'people-center-my-network-pending-invites-list-item'

class PendingInvitesListItem extends Component {
  @tracked inviteStatus = this.args.invite.isExpired ? INVITE_STATUSES.EXPIRED : INVITE_STATUSES.NONE;

  get className() {
    return CLASS_NAME;
  }

  get menuOptions() {
    const menuOptions = [];

    menuOptions.push({
      title: 'Resend invite',
      onClick: () => this.resendInvite.perform(),
    });

    menuOptions.push({
      title: 'Remove',
      onClick: () => this.args.removeInvitedUser.perform(this.args.invite),
    });

    return menuOptions;
  }

  get inviteStatusColor() {
    if (this.inviteStatus === INVITE_STATUSES.RESENT) return 'lsg-green';
    if (this.inviteStatus === INVITE_STATUSES.RESEND_FAILED) return 'lsg-medium-red';
    return null;
  }

  @enqueueTask
  *resendInvite() {
    try {
      yield this.args.resendInvite.perform(this.args.invite);
      this.inviteStatus = INVITE_STATUSES.RESENT;
    } catch {
      this.inviteStatus = INVITE_STATUSES.RESEND_FAILED;
    }
  }
}

export default PendingInvitesListItem;
